export enum ThemeType {
  Default = 1,
  Light,
  Dark
}
